"use client";

type LoaderProps = {
  label?: string;
};

export default function Loader({ label = "Loading" }: LoaderProps) {
  return (
    <div className="loader" role="status" aria-live="polite" aria-label={label}>
      <div className="loader-dots" aria-hidden="true">
        <span className="loader-dot dot-1" />
        <span className="loader-dot dot-2" />
        <span className="loader-dot dot-3" />
      </div>
    </div>
  );
}
